import React, { useEffect, useState } from "react";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  CartDetailedIcon,
  ChevronRightArrow,
  Curve,
  CurveOverImage,
  Phone,
  Time as TimeIcon,
  VoiceIcon,
} from "../../../components/svgs";
import {
  Button,
  CurveHolder,
  Span,
  StyledText,
  MainHolder,
  Children,
  Body,
  NotesContainer,
  CircleContainer,
  Dot,
  FooterImageContainer,
  FooterImage,
  FooterContainer,
  TipsContainer,
  TipContainer,
  Divider,
  DynamicButton,
} from "../../../components/common/basic";
import CountdownTimer from "../pulsenchill/components/CountdownTimer";
import { BackButton, FeatureHeader } from "../../../components/common";
import useSpeedShopping from "./hooks/useSpeedShopping";
import GenericModal from "../../../components/common/genericModal";
import MashupNowButton from "../mashupnwin/components/MashupNowButton";
import styled from "styled-components";

const now = new Date().getTime();
const SpeedShoppingHome = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "SpeedShoppingHome",
        firebase_screen_class: "SpeedShoppingHome",
      })
    );
  }, []);

  const {
    background,
    history,
    bannerImage,
    tailImage,
    tips,
    note,
    speedShoppingData,
    getSpeedShoppingData,
  } = useSpeedShopping();

  const {
    isLoading,
    timeRemaining,
    orders,
    startShopping,
    isQualified,
    hasEnded,
  } = speedShoppingData;

  useEffect(() => {
    getSpeedShoppingData();
  }, []);

  const [showRules, setShowRules] = useState(false);

  return (
    <>
      <MainHolder>
        <Children>
          {showRules && (
            <GenericModal>
              <div style={{ textAlign: "left" }}>
                <StyledText
                  size={24}
                  color={background}
                  style={{ fontFamily: "MTNMedium", margin: "0 0 20px 0" }}
                >
                  Things to note
                </StyledText>
                <div style={{ marginBottom: "30px" }}>
                  {[
                    "Upto 500ghc worth of shopping vouchers to be completed within 30 seconds.",
                    "Click/Tap plus icon to add vouchers into your cart.",
                    "Ensure to checkout to complete shopping. Failure to check out will cost you your vouchers.",
                    "Catalogue will be cleared after 5minutes of time-up shopping period.",
                    "Ensure to select your delivery location.",
                  ].map((text) => (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "top",
                        marginBottom: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          marginRight: "8px",
                        }}
                      >
                        <Dot
                          style={{ width: "8px", height: "8px", margin: 0 }}
                          color={background}
                        />
                      </div>
                      <StyledText
                        size={11}
                        margin={0}
                        style={{ fontFamily: "MTNRegular" }}
                      >
                        {text}
                      </StyledText>
                    </div>
                  ))}
                </div>

                <DynamicButton
                  color={background}
                  label="Start shopping"
                  onClick={() => {
                    setShowRules(false);
                    history.push("/speedshopping/cataloguehome");
                  }}
                />
              </div>
            </GenericModal>
          )}
          <BackButton onClick={() => history.goBack()} />
          <FeatureHeader
            image={bannerImage}
            title={["MTN Pulse", "Speed Shopping"]}
            buttonText="My Points"
            onClick={() => history.push("speedshopping/points")}
            background={background}
            secondaryBackground={"#fff"}
          >
            <CountdownTimer
              timeRemaining={isLoading ? null : timeRemaining}
              // timeRemaining={
              //   new Date("2022-12-5").getTime() - new Date().getTime()
              // }
              startTime={now}
              background={background}
              timeRunningContent={" "}
              timeUpContent={
                Array.isArray(orders) && orders.length > 0 ? (
                  <DynamicButton
                    label={"View order status"}
                    color={"#fff"}
                    textColor={"#000"}
                    onClick={() => history.push("/speedshopping/orders")}
                  />
                ) : hasEnded ? (
                  <DynamicButton
                    disabled
                    label={"Promo has ended"}
                    color={"#fff"}
                    textColor={"#000"}
                    onClick={() => {}}
                  />
                ) : (
                  <DynamicButton
                    disabled={!startShopping}
                    startIcon={
                      !isQualified ? null : (
                        <CartDetailedIcon width={20} fill={"#000"} />
                      )
                    }
                    label={
                      startShopping
                        ? "Start shopping"
                        : isQualified
                        ? "Shopping Starts Soon"
                        : "Sorry, you did not qualify to shop"
                    }
                    color={"#fff"}
                    textColor={"#000"}
                    onClick={() => setShowRules(true)}
                    endIcon={
                      startShopping ? (
                        <ChevronRightArrow width={20} fill={"#000"} />
                      ) : null
                    }
                  />
                )
              }
            />
          </FeatureHeader>

          <Body>
            {/* <Button onClick={() => history.push('/speedshopping/cataloguehome')}>Shop</Button> */}
            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              <StyledText
                size={24}
                style={{ fontFamily: "MTNRegularItalic", margin: "0 0 0px 0" }}
              >
                <Span style={{ fontFamily: "MTNBoldItalic" }}>{`Yello`}</Span>
                {" Peeps!"}
              </StyledText>
              <StyledText
                letterSpacing={-0.38}
                height={17}
                style={{ fontFamily: "MTNMedium", margin: "5px 0 24px 0" }}
                size={13}
              >
                The MTN Pulse speed shopping is back.
              </StyledText>

              <StyledText
                letterSpacing={-0.38}
                height={17}
                style={{ fontFamily: "MTNRegular" }}
                size={13}
              >
                Enjoy unlimited virtual shopping spree with the MTN Pulse Speed
                shopping promo. Speed Shopping is positioned as a reward for
                loyalty and high patronage of the Pulse bundles. An interactive
                shopping experience for MTN Pulse customers that has been in
                place over the last 6 years. In previous sessions, customers
                have been bused to partner shopping centers to participate in
                this interactive and fun experience.
              </StyledText>

              <StyledText
                letterSpacing={-0.38}
                height={17}
                style={{ fontFamily: "MTNRegular" }}
                size={13}
              >
                Owing to the prevalence of COVID-19 and the need to observe all
                protocols, the experience has gone virtual and even better.
                Simply hunt-out the loop for the virtual shopping and be an
                early bird to participate. Shop from a catalog of branded
                vouchers and select your preferred location for delivery.
              </StyledText>

              <MashupNowButton />
              <StyledText
                size={24}
                style={{ fontFamily: "MTNMedium", marginTop: "55px" }}
              >{`Things to note:`}</StyledText>

              {note.map((note, index) => {
                return (
                  <NotesContainer key={index}>
                    <CircleContainer>
                      <Dot color={background} />
                    </CircleContainer>
                    <StyledText
                      size={13}
                      style={{ fontFamily: "MTNRegular", marginBlockStart: 0 }}
                    >
                      {note}
                    </StyledText>
                  </NotesContainer>
                );
              })}

              <DynamicButton
                color={background}
                label="Terms & Conditions"
                onClick={() => {
                  setShowRules(false);
                  history.push("/privacy");
                }}
              />
            </div>
          </Body>
          {/* <CurveOverImage
            style={{
              position: "relative",
              zIndex: 1,
              marginTop: -10,
              width: "100%",
            }}
            fill={"white"}
          /> */}
          <FooterImageContainer>
            <FooterImage src={tailImage} />
          </FooterImageContainer>
          {/* <CurveHolder style={{ position: "relative", zIndex: 1 }}>
            <Curve fill={background} />
          </CurveHolder> */}
          <FooterContainer activeTheme={background}>
            <StyledText size={24} color={"white"} style={{ marginTop: 0 }}>
              Here's some tips
            </StyledText>
            <TipsContainer>
              {tips.map((tip, index) => {
                const icons = [
                  <TimeIcon width={25} height={25} />,
                  <VoiceIcon width={25} height={25} fill={"black"} />,
                  <Phone width={25} height={25} />,
                ];
                return (
                  <TipContainer key={index}>
                    {icons[index]}
                    <Divider />
                    <StyledText
                      size={11}
                      color={"black"}
                      style={{ marginTop: "6px" }}
                    >
                      {tip}
                    </StyledText>
                  </TipContainer>
                );
              })}
            </TipsContainer>
            <Button
              style={{ margin: "35px 0" }}
              onClick={() => {
                history.push("/speedshopping/faq");
              }}
              color={"white"}
            >
              <StyledText color={"black"}>
                {"Frequently asked questions"}
              </StyledText>
            </Button>
          </FooterContainer>
        </Children>
      </MainHolder>
    </>
  );
};

export default SpeedShoppingHome;
